'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uxcore = require('@ux/uxcore2');

var _botUtils = require('../bot-utils');

var _avatarWrapper = require('../components/avatar-wrapper');

var _avatarWrapper2 = _interopRequireDefault(_avatarWrapper);

var _app = require('../store/actions/app');

var _conversation = require('../store/selectors/conversation');

var _trafficManager = require('../traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-script-url*/


var seeMoreUrl = 'https://' + location.host + '/help/search';

/**
 * BotActionSearchResults
 *
 * @Constructor
 * @class BotActionSearchResults
 * @public
 */

var BotActionSearchResults = function (_React$Component) {
  _inherits(BotActionSearchResults, _React$Component);

  function BotActionSearchResults(props) {
    _classCallCheck(this, BotActionSearchResults);

    var _this = _possibleConstructorReturn(this, (BotActionSearchResults.__proto__ || Object.getPrototypeOf(BotActionSearchResults)).call(this, props));

    var resultsMessage = _this.props.msg;
    if (!resultsMessage) {
      resultsMessage = {
        results: []
      };
    }

    _this.state = {
      msg: resultsMessage
    };
    return _this;
  }

  /**
   * React method called after component mounted
   *
   * @private
   */


  _createClass(BotActionSearchResults, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _trafficManager2.default.sendSearchResultsEvent(this.props);
    }

    /**
     * Generate "see more" url string
     * @returns {string} Diagnostics message string
     *
     * @private
     */

  }, {
    key: 'getSeeMoreUrl',
    value: function getSeeMoreUrl() {
      var query = this.props.search && this.props.search.context && this.props.search.context.query;
      return query ? seeMoreUrl + '?q=' + query : seeMoreUrl;
    }

    /**
     * Handle link click event
     *
     * @param {Object} result The search result object containing the url string
     * @private
     */

  }, {
    key: 'handleClick',
    value: function handleClick(result) {
      this.props.appScrolledSet(false);
      _trafficManager2.default.sendLinkClickEvent('search', this.props.intent, this.props.sessionId, result.link);
    }

    /**
     * @returns {React.Element} renderSearchResults
     *
     * @param {Object} results The search results to render
     * @private
     */

  }, {
    key: 'renderSearchResults',
    value: function renderSearchResults(results) {
      var _this2 = this;

      var searchResults = results.map(function (result, index) {
        return _react2.default.createElement(
          'div',
          { className: 'search-results-item', key: index },
          _react2.default.createElement(
            'a',
            {
              onClick: function onClick() {
                return _this2.handleClick(result);
              },
              href: result.link,
              target: '_blank'
            },
            _react2.default.createElement(
              'div',
              { className: 'search-results-item-left' },
              _react2.default.createElement(
                'span',
                { className: 'search-results-item-title' },
                result.title
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'span',
                { className: 'search-results-item-location' },
                result.location
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_uxcore.Icon, { name: 'chevron-right-lt', size: 16 })
            )
          )
        );
      });

      searchResults.push(_react2.default.createElement(
        'div',
        { className: 'search-results-item', key: results.length },
        _react2.default.createElement(
          'a',
          {
            onClick: function onClick() {
              _trafficManager2.default.sendLinkClickEvent('search-see-more', _this2.props.intent, _this2.props.sessionId, _this2.getSeeMoreUrl());
            },
            href: this.getSeeMoreUrl(),
            target: '_blank'
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:SearchResults:SeeMore' }),
          _react2.default.createElement(
            'span',
            null,
            '\xA0\xA0>'
          )
        )
      ));

      return searchResults;
    }

    /**
     * @returns {React.Element} renderNoResults
     *
     * @private
     */

  }, {
    key: 'renderNoResults',
    value: function renderNoResults() {
      return _react2.default.createElement(
        'div',
        { className: 'search-results-item' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:SearchResults:NoResults' })
      );
    }

    /**
     * @returns {React.Element} render
     *
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _avatarWrapper2.default,
        { hidden: !(0, _botUtils.shouldShowAvatar)(this.props.conversation, this.props.index) },
        _react2.default.createElement(
          'div',
          { className: 'speech-bubble left' },
          this.state.msg.results.length > 0 ? this.renderSearchResults(this.state.msg.results) : this.renderNoResults()
        )
      );
    }
  }]);

  return BotActionSearchResults;
}(_react2.default.Component);

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


BotActionSearchResults.propTypes = {
  appScrolledSet: _propTypes2.default.func.isRequired,
  conversation: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  index: _propTypes2.default.number.isRequired,
  intent: _propTypes2.default.object.isRequired,
  msg: _propTypes2.default.object,
  search: _propTypes2.default.object,
  sessionId: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    conversation: (0, _conversation.conversationGet)(state)
  };
};

var mapDispatchToProps = {
  appScrolledSet: _app.appScrolledSet
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BotActionSearchResults);